import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseService} from '../services/base-service.service';
import {Processo} from '../processo/processo.model';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class ProcessoCompiladoService extends BaseService<Processo, number> {

  constructor(http: HttpClient) {
    super('processoCompilado', http);
  }

  public recompilar(id: number): Promise<Processo> {
    return firstValueFrom(this.http.patch<Processo>(this.path(`recompilar/${id}`), undefined));
  }
}
